import ConfirmDeletePaymentMethodPopUp from "./ConfirmDeletePaymentMethodPopUp";

export default ConfirmDeletePaymentMethodPopUp;
